import { X, Check } from "lucide-react";
import { Card } from "@/components/ui/card";

const comparisons = [
  {
    traditional: "Cobram produtividade constante",
    vyra: "Acolhem seu ritmo natural"
  },
  {
    traditional: "Julgam procrastinação",
    vyra: "Entendem paralisia executiva"
  },
  {
    traditional: "Interfaces complexas e sobrecarregadas",
    vyra: "Minimalismo funcional e suave"
  },
  {
    traditional: "Penalizam esquecimentos",
    vyra: "Capturam tudo sem esforço"
  },
];

const Comparison = () => {
  return (
    <section className="py-20 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12 space-y-4">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground">
            VYRA vs Apps tradicionais
          </h2>
          <p className="text-lg text-muted-foreground">
            Apps comuns não foram feitos pra TDAH. A gente foi.
          </p>
        </div>

        <Card className="p-8 md:p-12">
          <div className="space-y-6">
            {comparisons.map((item, idx) => (
              <div
                key={idx}
                className="grid md:grid-cols-2 gap-6 pb-6 border-b border-border last:border-0 last:pb-0"
              >
                {/* Apps Tradicionais */}
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-destructive/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <X className="w-4 h-4 text-destructive" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-muted-foreground mb-1">
                      Apps tradicionais
                    </p>
                    <p className="text-foreground">
                      {item.traditional}
                    </p>
                  </div>
                </div>

                {/* VYRA */}
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <Check className="w-4 h-4 text-primary" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-primary mb-1">
                      VYRA
                    </p>
                    <p className="text-foreground font-medium">
                      {item.vyra}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Card>
      </div>
    </section>
  );
};

export default Comparison;
